import { Component, inject, input } from '@angular/core';
import { IconComponent } from '@components';
import { CONFIG } from '@config';
import { RemoveApplianceDialogComponent } from '../remove-appliance-dialog/remove-appliance-dialog.component';

@Component({
  selector: 'app-basket-appliance',
  imports: [IconComponent],
  templateUrl: './basket-appliance.component.html',
  styleUrl: './basket-appliance.component.scss',
  providers: [RemoveApplianceDialogComponent],
})
export class BasketApplianceComponent {
  private readonly clientName = inject(CONFIG).clientName;
  canRemoveAppliance = input<boolean>(false);

  private readonly removeApplianceDialog = inject(
    RemoveApplianceDialogComponent,
  );

  onApplianceRemove(): void {
    this.removeApplianceDialog.open({ clientName: this.clientName });
  }
}
